module.exports = __webpack_public_path__ + "img/q3_sp.c2538462.svg";